import PortfolioSummary from './PortfolioSummary';
import State from 'store/State';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { OrderColumn } from 'communication/types/order/Order';
import { mapToStreamField } from 'app/store/orders/mapping';
import { WidgetStrategyWithConfig } from '../WidgetRegistry';
import {
    initialPortfolioSummaryConfiguration,
    PortfolioSummaryConfigurationState,
} from './store/instances/configuration/PortfolioSummaryConfigurationState';
import { selectPortfolioSummaryStreamingAggregationFields } from './store/data/selectors';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { portfolioSummaryDescription } from './description/portfolioSummaryDescription';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { aggregationFieldPortfolio } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';
import { PortfolioSelection } from 'portfolio/PortfolioSelection';
import { SymbolsService } from 'symbols/SymbolsService';

type PortfolioSummaryWidgetStrategy =
    WidgetStrategyWithConfig<PortfolioSummaryConfigurationState>;

export const portfolioSummaryWidgetStrategy: PortfolioSummaryWidgetStrategy = {
    title: 'Portfolio Summary',
    reactComponentType: PortfolioSummary,
    supportedHosts: ['layout'],
    getRequiredOrderColumns,
    initialConfigState: initialPortfolioSummaryConfiguration,
    categories: [WidgetCategory.PORTFOLIO],
    description: portfolioSummaryDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.Portfolio,
    getTitle,
};

function getRequiredOrderColumns(
    state: State,
    _widgetKey: string,
    _symbology: SymbologyValues
): OrderColumn[] {
    return [
        'side',
        'qty',
        'fillQty',
        'rem',
        'pncD',
        'avgPxC',
        ...selectPortfolioSummaryStreamingAggregationFields(state).map((f) =>
            mapToStreamField(state, f)
        ),
    ];
}

async function getTitle(
    _symbolsService: SymbolsService,
    _selection?: PortfolioSelection,
    config?: PortfolioSummaryConfigurationState
) {
    if (!config) {
        return undefined;
    }

    if (config.tabTitle) {
        return config.tabTitle;
    }

    const { aggregationField } = config;

    const text = aggregationField
        ? aggregationFieldPortfolio[aggregationField]?.text
        : 'Portfolio';

    return `${text} Summary`;
}
